module.exports = require("core-js/modules/esnext.weak-map.delete-all.js");